import { createResourceQuery } from './factory'

type Props = {
   organizationId?: string
   enabled?: boolean
}

export const useOrganizationNotification = createResourceQuery<'notification', Props, false>({
   queryKey: 'organization-notification',
   view: 'notification',
   order: [{ column: 'created_at', ascending: false }],
   filters: (query, props) => {
      if (props.organizationId) query.eq('organization_id', props.organizationId)
   },
})
